<template>
    <VideoHeader
        :banner-video="contentMeta.bannerVideo"
    >
        <template #default>
            <h1 class="page-title">{{ contentMeta.title }}</h1>

            <div
                v-if="contentMeta.switch"
                class="page-title text-body-1 mt-2"
            >
                <NuxtLink :to="contentMeta.switch">More details</NuxtLink>
            </div>
        </template>
    </VideoHeader>
</template>

<script lang="ts" setup>
    import type {
        ContentMeta
    } from '~/types';
    import VideoHeader from '~/components/video/VideoHeader/VideoHeader.vue';

    defineProps<{
        contentMeta: ContentMeta;
    }>();
</script>

<style lang="scss"></style>
